import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './publishModal.css';
import 'primeicons/primeicons.css';
import images from '../../../Utils/images';
import colors from '../../../Utils/colors';
import CheerioButton from '../../../Components/CheerioButton';
import { publishedWorkflowTemplate } from '../../../Services/index'
import { useSelector } from 'react-redux';
import SpinnerLoader from '../../../Components/SpinnerLoader';

import {
  Box, Typography,
  TextField,
  Select, MenuItem, FormControl,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { toast } from 'react-toastify';

const PublishWorkflowComponent = ({
  show,
  onClose,
  nodes,
  edges,
}: {
  show: boolean;
  onClose: (show: boolean) => void;
  nodes: any[];
  edges: any[];

}) => {

  const authtoken = useSelector((state: any) => state.main.auth_token);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [workflowJourney, setWorkflowJourney] = useState('');
  const [category, setCategory] = useState('');
  const [author, setAuthor] = useState('');
  const [isPublishing, setIsPublishing] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePublish = async () => {
    try {
      setLoading(true);
      const token = authtoken;
      const data = {
        name: name,
        description: description,
        workflowJourney: workflowJourney,
        category: category,
        authorName: author,
        nodes: nodes,
        edges: edges,
        type: "COMMUNITY",


      };
      const response = await publishedWorkflowTemplate(token, data);
      if (response?.flag) {
        setIsPublishing(true);
        setLoading(false);
        toast.success('Workflow published successfully', { position: 'top-center' });
      } else {
        toast.error(response?.message || 'Failed to publish workflow. Please try again.', { position: 'top-center' });
        console.error('Failed to publish workflow:', response?.message);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error publishing workflow:', error);
    }
  }

  const buttonText = isPublishing ? 'Published' : 'Unpublished';
  const buttoncolor = isPublishing ? '#04B100' : '#F5F5F5';
  const textcolor = isPublishing ? '#FFFFFF' : '#000000';

  return (
    <Modal
      show={show}
      onHide={() => onClose(false)}
      centered
      backdrop="static"
      keyboard={false}
      className="wallet-topup-modal"
    >

      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
            minHeight: "400px",
          }}
        >
          <SpinnerLoader />
          <p style={{ marginTop: "1rem" }}>Publishing your workflow. Please wait</p>
        </div>
      ) : (
        <div className="ai-modal-body">
          <div className="ai-modal-header">
            <h5 className="ai-title">Publish in community</h5>

            <div className="ai-header-right">
              <div
                style={{
                  backgroundColor: buttoncolor,
                  color: textcolor,
                  fontSize: 16,
                  fontWeight: 600,
                  borderRadius: "9px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 16px",
                }}
              >
                {buttonText}
              </div>

              <img
                src={images.CMClose}
                height={25}
                width={25}
                style={{ cursor: "pointer" }}
                onClick={() => onClose(false)}
                alt="Close"
              />
            </div>
          </div>

          <hr />
          <div className="publish-form">
            <Box sx={{ mb: 1 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>Name</Typography>
              <TextField
                fullWidth
                name="footer"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name your workflow"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: 'white',
                    '& fieldset': {
                      borderColor: '#CCCCCC',
                    },
                    '&:hover fieldset': {
                      borderColor: colors.primary03,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.primary03,
                    },
                  },
                }}
              />
            </Box>

            <Box sx={{ mb: 1 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>Description</Typography>
              <TextField
                fullWidth
                name="footer"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Describe your workflow in summary"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: 'white',
                    '& fieldset': {
                      borderColor: '#CCCCCC',
                    },
                    '&:hover fieldset': {
                      borderColor: colors.primary03,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.primary03,
                    },
                  },
                }}
              />
            </Box>
            <div className="form-group">
              <label style={{ marginBottom: 6 }}>Workflow Journey</label>
              <textarea
                placeholder="Define a step-by-step workflow journey..."
                value={workflowJourney}
                onChange={(e) => setWorkflowJourney(e.target.value)}
                className="form-control"
                rows={3}
              />
            </div>

            <Box sx={{ mb: 3, mt: 1 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>Category</Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  displayEmpty
                  renderValue={(selected) => selected || "Select category"}
                  sx={{
                    borderRadius: 2,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#CCCCCC',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.primary03,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.primary03,
                    },
                  }}
                  IconComponent={(props) => (
                    <ExpandMoreIcon {...props} sx={{ color: colors.primary03 }} />
                  )}
                >
                  <MenuItem value="Ecommerce">Ecommerce</MenuItem>
                  <MenuItem value="Banking">Banking</MenuItem>
                  <MenuItem value="Education">Education</MenuItem>

                  <MenuItem value="Realestate">RealEstate</MenuItem>
                  <MenuItem value="Healthcare">Healthcare</MenuItem>
                  <MenuItem value="Webinar">Webinar</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ mb: 1 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>Author/Created by</Typography>
              <TextField
                fullWidth
                name="footer"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                placeholder="Describe your workflow in summary"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: 'white',
                    '& fieldset': {
                      borderColor: '#CCCCCC',
                    },
                    '&:hover fieldset': {
                      borderColor: colors.primary03,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.primary03,
                    },
                  },
                }}
              />
            </Box>
          </div>

          <div style={{ marginLeft: '10px', marginTop: '1rem' }}>
            <CheerioButton
              borderStyle={{
                height: '36px',
                borderRadius: '9px',
                marginBlockStart: 12,
                marginBlockEnd: 8,
                marginBottom: '20px',
                border: 'none',
              }}
              textStyle={{ color: 'white', fontSize: 16, fontWeight: 600 }}
              btnText="Publish workflow to community"
              backColor="#8E53F7"
              onclick={() => {
                handlePublish();
              }}
              icon={null}
              id="send-report-btn"
              disabled={isPublishing}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PublishWorkflowComponent;